import type { FaireProductEntity } from "../../entity_types/product";

export const p_dub275f: FaireProductEntity = {
  token: "p_dub275f",
  type: "product",
  name: "Dried Fruit Medley",
  brandName: "Upstate Orchards",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/940210bb55e815c99267443067b07e79b14ff31c9575809d622d80d98df35659.webp",
  priceDollars: 12,
  description: "Naturally dried fruit medley with no added sugar",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "organic", "healthy"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/940210bb55e815c99267443067b07e79b14ff31c9575809d622d80d98df35659.webp",
  weight: 0.4,
  dimensions: {
    width: 4,
    height: 6,
    depth: 2,
  },
  inStock: true,
};
